import { EntityProfileHeaderInfoItemText } from '../../../Entity'
import {
  NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_ACTIONS_PROPS,
  NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_TITLE_KEYS,
} from '../NewsboardPostProfileHeaderInfoItems.constants'

import * as styles from '../NewsboardPostProfileHeaderInfoItems.module.css'

function NewsboardPostProfileHeaderInfoItem({
  canEdit,
  name,
  value,
  ...restProps
}) {
  return (
    <EntityProfileHeaderInfoItemText
      {...restProps}
      canEdit={canEdit}
      contentWrapperClassName={
        canEdit ? styles.editableContentWrapper : undefined
      }
      itemActionsProps={
        NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_ACTIONS_PROPS[name]
      }
      noDataText='Select.NoDataKey'
      title={NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_TITLE_KEYS[name]}
      value={value}
    />
  )
}

export default NewsboardPostProfileHeaderInfoItem
